var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14 .875v4.58a.875.875 0 1 1-1.75 0V2.987L8.992 6.245a.875.875 0 0 1-1.237-1.237l3.258-3.258H8.545a.875.875 0 1 1 0-1.75h4.58c.483 0 .875.392.875.875ZM0 13.125c0 .483.392.875.875.875h4.58a.875.875 0 1 0 0-1.75H2.987l3.258-3.258a.875.875 0 1 0-1.237-1.237L1.75 11.013V8.545a.875.875 0 0 0-1.75 0v4.58Z"
  })));
};
export { SvgExpand as ReactComponent };
export default __webpack_public_path__ + "8fc824875469470d71f6b73fd4f57c7c.svg";